import(/* webpackMode: "eager" */ "/srv/stocks-in-global/apps/web/app/global-error.tsx");
